import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useLanguage();

  return (
    <button
      className="toggle-btn"
      onClick={toggleTheme}
      aria-label="Toggle theme"
      title={theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
    >
      {theme === 'light' ? (
        <>
          <i className="bi bi-moon-stars-fill"></i>
          <span className="d-none d-md-inline">{t('common.darkMode')}</span>
        </>
      ) : (
        <>
          <i className="bi bi-sun-fill"></i>
          <span className="d-none d-md-inline">{t('common.lightMode')}</span>
        </>
      )}
    </button>
  );
};

export default ThemeToggle;
